/**
 * Documentación:
 * 
 * Este archivo contiene el componente RPPForm, que representa un formulario para realizar
 * consultas relacionadas con el Registro Público de la Propiedad (RPP).
 * 
 * El formulario recopila información como el nombre o razón social, los apellidos del propietario,
 * y opcionalmente un segundo apellido.
 * 
 * Una vez que se completa el formulario y se envía, se realiza una llamada al endpoint del backend
 * '/api/rpp' para enviar la información ingresada. Luego, el componente espera la respuesta
 * del backend y llama a la función submitCallback con los resultados obtenidos.
 */

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import { Navigate, useNavigate } from "react-router-dom";

// Definición del componente funcional RPPForm
const RPPForm = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombreRazonSocial, setNombreRazonSocial] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [processing, setProcessing] = useState(false); 
  const [error, setError] = useState(null); 
  const navigate = useNavigate() 
  const handleSubmit = (e) => {
    e.preventDefault();
    const url= `/busqueda-rpps?nombre=${nombreRazonSocial}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}`



    navigate(url)
    
  };
  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre/Razón Social:
          <input type="text" value={nombreRazonSocial} onChange={(e) => setNombreRazonSocial(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
     <button className='button2' type="submit" disabled={processing}>
        {processing ? 'Buscando...' : 'Buscar'}
      </button>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className="error-message">{error}</div>}

    </form>
  );
};

// Exportar el componente RPPForm
export default RPPForm;
